import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatError } from "../lib/api";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

const REG = [["darpan", "NITI Aayog Darpan"], ["12a", "12A"], ["80g", "80G"], ["fcra", "FCRA"], ["trust_deed", "Trust deed"], ["society", "Society registration"], ["section8", "Section 8 company"], ["other", "Other / foreign equivalent"]];
const FIELDS = [
  ["org_name", "Organisation name", "text"], ["contact_name", "Contact person", "text"], ["email", "Email (your login)", "email"],
  ["password", "Create a password", "password"], ["phone", "Phone", "tel"], ["registration_number", "Registration number", "text"],
  ["pan", "Organisation PAN (e.g. AAATG1234K)", "text"], ["website", "Website (optional)", "url"],
];

export default function NgoApply() {
  const [f, setF] = useState({ registration_type: "darpan", address: "", mission: "" });
  const [cert, setCert] = useState(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!cert) return toast.error("Please attach your registration certificate");
    const fd = new FormData();
    Object.entries(f).forEach(([k, v]) => fd.append(k, v || ""));
    fd.append("certificate", cert);
    setBusy(true);
    try { await api.post("/ngos/apply", fd); setDone(true); } catch (err) { toast.error(formatError(err)); } finally { setBusy(false); }
  };

  if (done) return (
    <div data-testid="ngo-apply-success" className="max-w-xl mx-auto px-4 py-24 text-center">
      <div className="font-devanagari text-6xl text-[#D4AF37]">ॐ</div>
      <h1 className="font-serif text-4xl text-[#4A0E17] mt-4">Application received</h1>
      <p className="text-[#63534E] mt-4">We'll check your documents within 3 working days. Then <Link to="/login" className="text-[#E65100] font-semibold">sign in</Link> to choose a tier and request project funding.</p>
    </div>
  );

  return (
    <div data-testid="ngo-apply-page" className="max-w-3xl mx-auto px-4 sm:px-6 py-14">
      <div className="overline">NGO Partner Program</div>
      <h1 className="font-serif text-4xl sm:text-5xl text-[#4A0E17] mt-2">Register your NGO</h1>
      <p className="text-[#63534E] mt-4">Only registered NGOs can join. Your certificate and PAN stay private and are seen only by our verification team.</p>
      <form onSubmit={submit} className="mt-10 bg-[#FFFDF9] sacred-border rounded-3xl p-7 grid sm:grid-cols-2 gap-4">
        {FIELDS.map(([k, ph, type]) => (
          <Input key={k} data-testid={`ngo-${k}`} required={!["phone", "website"].includes(k)} type={type} placeholder={ph} value={f[k] || ""} onChange={set(k)}
            minLength={k === "password" ? 6 : undefined} className="bg-white border-[#D4AF37]/40 h-11" />
        ))}
        <select data-testid="ngo-registration_type" value={f.registration_type} onChange={set("registration_type")} className="h-11 rounded-md border border-[#D4AF37]/40 bg-white px-3 text-sm sm:col-span-2">
          {REG.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
        <Textarea data-testid="ngo-address" required minLength={10} rows={2} placeholder="Registered address" value={f.address} onChange={set("address")} className="bg-white border-[#D4AF37]/40 sm:col-span-2" />
        <Textarea data-testid="ngo-mission" required minLength={20} rows={4} placeholder="Your mission and the work you do (at least 20 characters)" value={f.mission} onChange={set("mission")} className="bg-white border-[#D4AF37]/40 sm:col-span-2" />
        <label className="sm:col-span-2 text-sm text-[#4A0E17]">Registration certificate (PDF or image, max 8MB)
          <input data-testid="ngo-certificate" type="file" accept="image/*,application/pdf" onChange={(e) => setCert(e.target.files?.[0])} className="block mt-2 text-xs" />
        </label>
        <Button data-testid="ngo-submit" disabled={busy} className="sm:col-span-2 bg-[#E65100] hover:bg-[#BF360C] rounded-full h-12">{busy ? "Submitting…" : "Submit for verification"}</Button>
      </form>
    </div>
  );
}
